export const splitQuestionTextOptionalLabel = (questionText = "") => {
  const questionTextRaw = typeof questionText === "string" ? questionText : ""
  const optionalSeparatorIndex = questionTextRaw.indexOf("?")

  if (optionalSeparatorIndex === -1) {
    return [questionTextRaw, ""]
  }

  return [
    questionTextRaw.slice(0, optionalSeparatorIndex + 1),
    questionTextRaw.slice(optionalSeparatorIndex + 1).trim(),
  ]
}
